// CO - Kit montado: eventos de rastreamento (dataLayer -> GTM -> GA4).
//
// POR QUE NOME PRÓPRIO (kit_*) E NÃO OS EVENTOS PADRÃO
// O pixel nativo do canal Google (apiClientId 1780363) já manda o e-commerce
// inteiro pro G-0PF1R7ZPC5 E pro Ads. Verificado na página: ao adicionar um kit
// de 4 peças ele dispara QUATRO `add_to_cart`, um por peça, todos a preço cheio
// — inclusive o tênis, que a function `kit-montado` só zera no checkout.
//
// Repetir `add_to_cart` ou `view_item` daqui dobraria a métrica padrão e
// contaminaria o ROAS. Foi por isso que a tag `#_add_to_cart_SINGLE` do GTM foi
// neutralizada de propósito lá atrás. A regra é: um evento, um caminho.
//
// Então este arquivo mede a OFERTA, não a mercadoria — o funil do kit vive em
// eventos `kit_*`, ao lado do funil de produto, sem competir com ele. O
// `kit_added` é o único lugar onde "um kit, valor X" existe como evento único.
//
// A atribuição peça -> kit NÃO passa por aqui: toda linha carrega a property
// `_conso_kitm` e ela persiste no pedido, então isso se responde no Shopify com
// mais fidelidade do que o GA4 daria (devolução inclusive).

(() => {
  if (window.__consoKitTracking) return;
  window.__consoKitTracking = true;

  const push = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  // Kit que clicou em adicionar e ainda espera a confirmação do carrinho.
  let pendente = null;

  // A faixa de looks nasce dentro do bloco mas o `conso-kit-montado.js` a move
  // pra dentro da <media-gallery>, que é irmã do kit dentro do `.conso-kit` da
  // section. Depois do move o `closest` não alcança mais o kit — sem o fallback
  // pela section, `kit_look_select` não dispara nenhuma vez.
  const kitDe = (el) =>
    el?.closest('conso-kit-montado') ||
    el?.closest('.conso-kit, .shopify-section')?.querySelector('conso-kit-montado') ||
    null;

  const dados = (raiz) => ({
    kit_id: raiz.dataset.kmId || '',
    kit_token: raiz.dataset.kmToken || '',
    kit_name: raiz.dataset.kmNome || '',
    kit_valor: Number(raiz.dataset.kmValor || 0),
    kit_pecas: raiz.querySelectorAll('[data-km-slot]').length,
  });

  // Um marcador por evento no próprio elemento: os eventos de etapa contam
  // CLIENTES que chegaram ali, não cliques. Sem isso, quem troca de cor cinco
  // vezes vira cinco `kit_config_start` e a taxa de abandono perde o sentido.
  const umaVezPorKit = (raiz, marca) => {
    if (raiz.dataset[marca] === '1') return false;
    raiz.dataset[marca] = '1';
    return true;
  };

  /* ------------------------------------------------------- completude do kit */

  // Slot de produto de uma opção só não tem fileira de tamanho — nasce completo.
  const slotCompleto = (slot) => {
    const tamanhos = slot.querySelectorAll('[data-km-tam]');
    if (tamanhos.length === 0) return true;
    return Array.from(tamanhos).some((input) => input.checked);
  };

  const slotsFaltando = (raiz) =>
    Array.from(raiz.querySelectorAll('[data-km-slot]')).filter((slot) => !slotCompleto(slot));

  /* ------------------------------------------------------------- kit_view */

  // Serve pros dois casos com um mecanismo só: o kit inline entra na viewport ao
  // rolar, e o kit do carrossel está dentro de um <dialog> fechado (ratio 0) até
  // o `showModal()` — aí o observer dispara sozinho. Sem gancho no carrossel.
  const observador = new IntersectionObserver(
    (entradas) => {
      for (const entrada of entradas) {
        if (!entrada.isIntersecting) continue;

        const raiz = entrada.target;
        observador.unobserve(raiz);
        if (!umaVezPorKit(raiz, 'trkView')) continue;

        push({
          event: 'kit_view',
          kit_origem: raiz.closest('dialog') ? 'modal' : 'pagina',
          ...dados(raiz),
        });
      }
    },
    { threshold: 0.5 }
  );

  const observar = () => {
    for (const raiz of document.querySelectorAll('conso-kit-montado')) {
      if (raiz.dataset.trkObs === '1') continue;
      raiz.dataset.trkObs = '1';
      observador.observe(raiz);
    }
  };

  /* ------------------------------------------------- montagem (cor/tamanho) */

  document.addEventListener('change', (evento) => {
    const alvo = evento.target;
    if (!(alvo instanceof Element)) return;
    if (!alvo.matches('[data-km-cor], [data-km-tam]')) return;

    const raiz = kitDe(alvo);
    if (!raiz) return;

    if (umaVezPorKit(raiz, 'trkStart')) {
      push({ event: 'kit_config_start', ...dados(raiz) });
      raiz.dataset.trkStartTs = String(Date.now());
    }

    if (slotsFaltando(raiz).length > 0) return;
    if (!umaVezPorKit(raiz, 'trkComplete')) return;

    const inicio = Number(raiz.dataset.trkStartTs || 0);

    push({
      event: 'kit_config_complete',
      kit_segundos: inicio ? Math.round((Date.now() - inicio) / 1000) : null,
      ...dados(raiz),
    });
  });

  /* ------------------------------------------------------------ interações */

  document.addEventListener('click', (evento) => {
    const alvo = evento.target instanceof Element ? evento.target : null;
    if (!alvo) return;

    // Look pré-montado
    const look = alvo.closest('[data-km-look]');
    if (look) {
      const raiz = kitDe(look);
      if (raiz) {
        push({
          event: 'kit_look_select',
          kit_look: look.getAttribute('aria-label') || look.getAttribute('title') || '',
          ...dados(raiz),
        });
      }
      return;
    }

    // Gaveta de medidas: abertura e troca de aba no mesmo evento, separadas pelo
    // parâmetro. O que se quer saber é se o provador é procurado ou se a tabela
    // basta — duas métricas com o mesmo denominador respondem melhor que dois
    // eventos soltos.
    const medidas = alvo.closest('[data-km-medidas]');
    if (medidas) {
      const raiz = kitDe(medidas);
      if (raiz) {
        push({
          event: 'kit_size_guide',
          kit_tab: 'medidas',
          kit_peca: medidas.dataset.kmMedidasTitulo || '',
          ...dados(raiz),
        });
      }
      return;
    }

    const aba = alvo.closest('[data-kmm-aba]');
    if (aba) {
      if (aba.getAttribute('aria-selected') === 'true') return;

      const gaveta = aba.closest('dialog.kmm');
      const raiz = kitDe(gaveta);
      if (raiz) {
        push({
          event: 'kit_size_guide',
          kit_tab: aba.dataset.kmmAba || '',
          kit_peca: gaveta.querySelector('[data-kmm-titulo]')?.textContent?.trim() || '',
          ...dados(raiz),
        });
      }
      return;
    }

    // Adicionar ao carrinho
    const add = alvo.closest('[data-km-add]');
    if (!add) return;

    const raiz = kitDe(add);
    if (!raiz) return;

    const faltando = slotsFaltando(raiz);

    if (faltando.length > 0) {
      // Atrito no ponto exato: se este número for alto, o problema é o
      // formulário e não a oferta. O pixel nativo nunca enxerga isto — do lado
      // dele não aconteceu nada.
      push({
        event: 'kit_add_blocked',
        kit_faltando: faltando.length,
        kit_faltando_slots: faltando.map((s) => s.dataset.kmNome || '').join(', '),
        ...dados(raiz),
      });
      return;
    }

    // O `cart:update` chega no document sem referência ao elemento, então o kit
    // é armado aqui e confirmado lá — mesmo padrão do conso-kit-upsell.js.
    pendente = raiz;
  }, true);

  /* -------------------------------------------------------------- kit_added */

  document.addEventListener('cart:update', (evento) => {
    if (evento.detail?.data?.source !== 'conso-kit-montado') return;

    const raiz = pendente;
    pendente = null;
    if (!raiz) return;

    push({ event: 'kit_added', ...dados(raiz) });
  });

  // Add recusado pelo servidor (variante esgotou entre o render e o clique):
  // sem isto o kit ficaria armado e o próximo `cart:update` de outra origem
  // marcaria uma adição que não houve.
  //
  // E o cliente que chega aqui montou o kit inteiro e saiu de mãos vazias — sem
  // um evento próprio ele some do funil entre `kit_config_complete` e nada. O
  // `kit_add_blocked` não cobre este caso: lá o formulário estava incompleto e
  // a página nem tentou; aqui tentou e o servidor recusou.
  document.addEventListener('cart:error', (evento) => {
    const raiz = pendente;
    pendente = null;

    // Sem kit armado é o caminho do tamanho faltando, que já saiu como
    // `kit_add_blocked` no clique.
    if (!raiz) return;

    push({
      event: 'kit_add_error',
      kit_erro: evento.detail?.data?.kmErro || '',
      ...dados(raiz),
    });
  });

  /* ----------------------------------------------------------------- início */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observar, { once: true });
  } else {
    observar();
  }
})();
